'use client';

import { c as _c } from "react/compiler-runtime";
import { SidebarThemeToggle } from '@repo/features/theme-toggle';
import { getAppVersion } from '@repo/sdk/version';
import { Sidebar, SidebarContent, SidebarFooter, SidebarMenu, SidebarMenuItem, useSidebar } from '@repo/ui/components';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useEffectEvent } from 'react';
import { NavUser } from '@/app/@protected/_components/sidebar/nav-user.tsx';
import { AppSidebarContent } from '@/app/@protected/_components/sidebar/sidebar-content.tsx';
import { AppSidebarHeader } from '@/app/@protected/_components/sidebar/sidebar-header.tsx';
import { LoadsSidebarGroup } from '@/app/@protected/_components/sidebar/loads-sidebar-group.tsx';
import { adminItems, companyItems, otherItems } from '@/app/@protected/_components/sidebar/sidebar-nav-content.tsx';
import packageJson from '../../../../../package.json';
export const AppSidebar = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getAppVersion(packageJson);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const version = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    setOpenMobile
  } = useSidebar();
  let t1;
  if ($[1] !== setOpenMobile) {
    t1 = () => setOpenMobile(false);
    $[1] = setOpenMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const closeMobileSidebar = useEffectEvent(t1);
  let t2;
  if ($[3] !== closeMobileSidebar) {
    t2 = () => {
      closeMobileSidebar();
    };
    $[3] = closeMobileSidebar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== pathname || $[6] !== searchParams) {
    t3 = [pathname, searchParams];
    $[5] = pathname;
    $[6] = searchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AppSidebarHeader data-sentry-element="AppSidebarHeader" data-sentry-source-file="app-sidebar.tsx" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarContent data-sentry-element="SidebarContent" data-sentry-source-file="app-sidebar.tsx"><LoadsSidebarGroup data-sentry-element="LoadsSidebarGroup" data-sentry-source-file="app-sidebar.tsx" /><AppSidebarContent {...companyItems} data-sentry-element="AppSidebarContent" data-sentry-source-file="app-sidebar.tsx" /><AppSidebarContent {...otherItems} data-sentry-element="AppSidebarContent" data-sentry-source-file="app-sidebar.tsx" /><AppSidebarContent {...adminItems} data-sentry-element="AppSidebarContent" data-sentry-source-file="app-sidebar.tsx" /></SidebarContent>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SidebarThemeToggle data-sentry-element="SidebarThemeToggle" data-sentry-source-file="app-sidebar.tsx" />;
    t7 = <NavUser data-sentry-element="NavUser" data-sentry-source-file="app-sidebar.tsx" />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Sidebar collapsible="icon" variant="inset" data-sentry-element="Sidebar" data-sentry-component="AppSidebar" data-sentry-source-file="app-sidebar.tsx">{t4}{t5}<SidebarFooter data-sentry-element="SidebarFooter" data-sentry-source-file="app-sidebar.tsx"><SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="app-sidebar.tsx">{t6}{t7}<SidebarMenuItem className="px-2" data-sentry-element="SidebarMenuItem" data-sentry-source-file="app-sidebar.tsx"><p className="text-xs text-muted-foreground">{version}</p></SidebarMenuItem></SidebarMenu></SidebarFooter></Sidebar>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};